<template>
  <div class="detail-sell-out">
    <div class="sell-info">
      <div class="header-title">
        <div class="left-wrapper">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.salesPerformancePcs') }}</div>
        </div>
        <div class="sell-out-btn" @click="toSellOut('')" v-if="!eventInfoObj.isDisable && eventInfoObj.status !== 0">+ {{ $t('button.sellOut') }}</div>
      </div>
      <div class="sell-main-content">
        <div class="main-header">
          <span>{{ $t('form.totalSalesPcs') }}：</span>
          <span class="total-num">{{ productListTotal }}</span>
        </div>
        <div class="sell-item" v-for="item in productList" :key="item.productId">
          <span>{{ item.productName }}</span>
          <span class="product-num">{{ item.productCount }}</span>
        </div>
      </div>
      <div class="sell-main-content">
        <div class="main-header">
          <span>{{ $t('form.sampleGiveawayPcs') }}：</span>
          <span class="total-num">{{ protoListTotal }}</span>
        </div>
        <div class="sell-item" v-for="item in protoList" :key="item.productId">
          <span>{{ item.productName }}</span>
          <span class="product-num">{{ item.productCount }}</span>
        </div>
      </div>
    </div>
    <div class="sell-info sellout-product" v-show="this.eventInfo.schedule !== '-1'">
      <div class="header-title">
        <div class="left-wrapper">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.sellOutOrders') }}</div>
        </div>
      </div>
      <div class="sell-main-content">
        <div class="main-header">
          {{ $t('form.total') }}: {{ totalRow }} {{ $t('form.orders') }}
        </div>
        <div></div>
        <van-row class="row-order" gutter="10" v-for="subItem in orderList" :key="subItem.id">
          <van-col span="6">{{ subItem.localCreateTime }}</van-col>
          <van-col span="14" class="sell-out-name">{{ subItem.productName }}</van-col>
          <van-col span="4">
            <div class="order-num" @click="toSellOut(subItem.id)">{{ subItem.saleCount }}</div>
          </van-col>
        </van-row>
        <van-pagination class="pagination-content" v-model="page" :total-items="totalRow" :show-page-size="3" items-per-page="15">
          <template #prev-text>
            <van-icon name="arrow-left" />
          </template>
          <template #next-text>
            <van-icon name="arrow" />
          </template>
          <template #page="{ text }">{{ text }}</template>
        </van-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { arsEventSellListPageApi, arsEventSellOutGeneralApi } from '@/api/event'
import { Toast } from 'vant'
export default {
  props: {
    eventInfoObj: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      page: 1,
      totalRow: 0,
      orderList: [],
      productList: [],
      protoList: []
    }
  },
  activated () {
    this.getListPageInfo()
    this.getEventSellOutGeneralData()
  },
  mounted () {
    this.getListPageInfo()
    this.getEventSellOutGeneralData()
  },
  computed: {
    ...mapState('event', ['eventInfo']),
    productListTotal () {
      return this.productList.reduce((acc, curr) => acc + curr.productCount, 0)
    },
    protoListTotal () {
      return this.protoList.reduce((acc, curr) => acc + curr.productCount, 0)
    }
  },
  methods: {
    toSellOut (sellOutId = '') {
      if (this.eventInfoObj.isDisable && this.eventInfoObj.status !== 0) return
      this.$router.push({
        path: '/sellOutAdd',
        query: { eventId: this.eventInfo.eventId, sellOutId: sellOutId, eventActive: 1 }
      })
    },
    getEventSellOutGeneralData () {
      arsEventSellOutGeneralApi(this.eventInfo.eventId, this.eventInfo.schedule).then(res => {
        this.productList = res.data.productList
        this.protoList = res.data.protoList
      })
    },
    getListPageInfo () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsEventSellListPageApi(this.eventInfo.eventId, { page: this.page, schedule: this.eventInfo.schedule }).then(res => {
        Toast.clear()
        this.orderList = res.data.list
        this.totalRow = Number(res.data.totalRow)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-sell-out {
  .header-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left-wrapper {
      display: flex;
      align-items: center;
      .blue-bar {
        width: 5px;
        height: 16px;
        background-color: #307bff;
        margin-right: 5px;
      }
      .title-text {
        font-weight: bold;
        font-size: 13px;
        color: #333;
      }
    }
  }
  .sell-info {
    margin-bottom: 20px;
    .sell-main-content {
      padding: 0 10px;
      .main-header {
        padding: 10px 0;
        border-top: 1px solid #e8effc;
        border-bottom: 2px solid #e8effc;
        font-size: 13px;
        .total-num {
          font-weight: bold;
          color: #307bff;
        }
        &:first-child {
          border-top: none;
        }
      }
      .sell-item {
        display: flex;
        justify-content: space-between;
        font-size: 11px;
        padding: 10px 6px;
        border-bottom: 1px solid #e8effc;
        .product-num {
          font-weight: bold;
          color: #307bff;
        }
      }
    }
  }
  .sell-out-btn {
    padding: 5px 3px;
    background-color: #e8effc;
    border-radius: 5px;
    font-size: 11px;
    border: 1px solid #307bff;
    color: #307bff;
    margin-right: 10px;
  }
  .sellout-product {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .row-order {
    padding: 10px 6px;
    border-bottom: 1px solid #e8effc;
    .order-num {
      color: #307bff;
      text-decoration: underline;
    }
    .sell-out-name {
      word-break: break-word;
    }
  }
  .pagination-content {
    margin: 10px 0;
    justify-content: flex-end;
    /deep/.van-pagination__item {
      flex: none;
      min-width: 26px;
      width: 26px;
      height: 26px;
      margin-right: 10px;
      font-size: 12px;
      background-color: #e8effc;
      border: 1px solid #7f7f7f;
      color: #7f7f7f;
    }
    /deep/.van-pagination__prev,
    /deep/.van-pagination__next {
      width: 26px;
      height: 26px;
    }
    /deep/.van-pagination__item--active {
      border: 1px solid #307bff;
      color: #307bff;
    }
  }
}
</style>
